import styled from 'styled-components';
import Input from './Input';

export const DateInput = styled(Input) `
  height: 1.5rem;
  width: ${props => (props.width ? props.width : '6.75rem')};

  &::-webkit-clear-button,
  &::-webkit-inner-spin-button {
    display: none;
  }

  &::-webkit-calendar-picker-indicator {
    background: url('images/calendar.png') top left no-repeat;
    color: rgba(0, 0, 0, 0);
    height: .75rem;
    width: .75rem;
    opacity: 1;
  }
`;

export const TimeInput = styled(Input) `
  background: white url('images/clock.png') 95% 50% no-repeat;
  height: 1.5rem;
  width: ${props => (props.width ? props.width : '6.75rem')};

  &::-webkit-clear-button {
    display: none;
  }

  &::-webkit-inner-spin-button {
    margin-right: 1.5rem;
  }
`;



// WEBPACK FOOTER //
// ./app/styled-components/DateTimeInput.js